module.exports = __webpack_public_path__ + "static/media/japanese-particles-table-1.a3711e2f.PNG";